import React from 'react';
import PropTypes from 'prop-types';
import { BackButtonWrapper } from './styled.jsx';
import { BackIcon } from '../common/Icon';

export const BackButton = ({ className = null, onClick = undefined, ...rest }) => {
  return (
    <BackButtonWrapper {...rest} className={className} role="button" onClick={onClick} onKeyDown={onClick}>
      <BackIcon />
    </BackButtonWrapper>
  );
};

BackButton.propTypes = {
  /**
   * What className to use
   */
  className: PropTypes.string,
  /**
   * Optional click handler
   */
  onClick: PropTypes.func,
};
